<!-- 小云爱学绑定状态 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="bindStatus" type="bindStatus" clearable />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-绑定状态选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '家长端状态：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const bindStatus = useQuery('bindStatus', props.value);

    return {
      bindStatus,
    };
  },
};
</script>
